import React, { useCallback, useEffect } from 'react'
import { Grid, Link, Stack, Typography } from '@mui/material'
import { Trans } from 'react-i18next'
import OnboardingHeader from '../../components/OnboardingHeader/OnboardingHeader'
import OnboardingNavigation from '../../components/OnboardingNavigation/OnboardingNavigation'
import { useAppSelector } from '../../../../store/utils/hooks'
import { selectOnboardingData } from '../../../../store/slices/user/userSlice'
import { useTheme } from '@mui/material/styles'
import useCheckVerification from '../../../../utils/Firebase/hooks/useCheckVerification'
import { RefreshCw } from 'react-feather'
import { sendVerification } from '../../../../utils/Firebase/methods'
import { useNavigate } from 'react-router-dom'
import { HOME_PATH } from '../../../../routes/HomeRoutes'
import { useOnboardingProgress } from '../../hooks/useOnboardingProgress'
import TagManager from '@sooro-io/react-gtm-module'
import { gtmConfig } from '../../../../config/gtm'

export default function ValidationSection() {
	const onboardingData = useAppSelector(selectOnboardingData)
	const navigate = useNavigate()
	const { palette } = useTheme()
	const { userIsVerified } = useCheckVerification()
	const hasCompletedRegister = useOnboardingProgress('register', '')

	const navForward = useCallback(() => navigate(HOME_PATH), [navigate])

	useEffect(() => {
		if (gtmConfig.enabled) {
			TagManager.dataLayer({
				dataLayer: {
					event: 'formInteraction',
					formInteraction: {
						property: 'webflow',
						form: 'accountSignUp',
					},
				},
			})
		}
	}, [])

	if (!hasCompletedRegister) {
		return null
	}

	return (
		<Grid container maxWidth="100%" justifyContent="center">
			<Grid item xs={0} sm={2} md={2} />
			<Grid item xs={12} sm={4} md={4} lg={4}>
				<Stack gap="16px" marginBottom="32px">
					<img src="/assets/images/onboarding/email_check.svg" alt="" width="52px" />
					<Typography fontSize="12px">
						<Trans i18nKey="onboarding.layout.step_2" components={{ b: <b /> }} />
					</Typography>
					<OnboardingHeader i18nHeader="onboarding.validation.title" />
					<Typography fontSize="14px" color={palette.text.darkGrey}>
						<Trans
							i18nKey="onboarding.validation.subtitle"
							components={{ bold: <b style={{ color: palette.brand.main }} /> }}
							values={{ email: onboardingData.email }}
						/>
					</Typography>
					{!userIsVerified && (
						<Typography fontSize="14px" sx={{ color: palette.brand.main }}>
							<RefreshCw style={{ width: '20px', height: '20px', marginRight: '10px' }} />
							<Trans
								i18nKey="onboarding.validation.re_send_confirmation_link"
								components={{
									anchor: (
										<Link
											onClick={() => sendVerification()}
											sx={{
												textDecoration: 'underline',
												cursor: 'pointer',
												verticalAlign: 'top',
												color: palette.brand.main,
											}}
										/>
									),
								}}
							/>
						</Typography>
					)}
					<OnboardingNavigation
						i18nForwardLabel="onboarding.validation.next_button_label"
						forwardClick={navForward}
					/>
				</Stack>
			</Grid>
			<Grid item xs={0} sm={2} md={2} />
		</Grid>
	)
}
